import React from 'react';
import { Grid, TextField, Typography } from '@mui/material';

export const OWNER_USERNAME_PATTERN = /^[A-Za-z][A-Za-z0-9_]{0,127}$/;

const RESERVED = new Set(['sa', 'dbo', 'guest', 'public', 'sys', 'information_schema']);

export function validateOwnerLogin(
  username: string,
  password: string,
  confirmPassword: string,
): string | null {
  const user = username.trim();
  if (!user) return 'El usuario SQL es obligatorio';
  if (user.length > 128) return 'El usuario SQL no puede superar 128 caracteres';
  if (!OWNER_USERNAME_PATTERN.test(user)) {
    return 'El usuario SQL debe empezar con una letra y solo puede contener letras, números y guiones bajos';
  }
  if (RESERVED.has(user.toLowerCase())) return `El usuario SQL "${user}" no puede ser owner de la base`;
  if (!password) return 'La contraseña del login SQL es obligatoria';
  if (password.length < 6) return 'La contraseña debe tener al menos 6 caracteres';
  if (password.length > 128) return 'La contraseña no puede superar 128 caracteres';
  if (password !== confirmPassword) return 'Las contraseñas no coinciden';
  return null;
}

interface TenantOwnerLoginFieldsProps {
  username: string;
  password: string;
  confirmPassword: string;
  disabled?: boolean;
  createsDatabase?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const TenantOwnerLoginFields: React.FC<TenantOwnerLoginFieldsProps> = ({
  username,
  password,
  confirmPassword,
  disabled = false,
  createsDatabase = false,
  onChange,
}) => (
  <>
    <Grid item xs={12}>
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#111827' }}>
        Login de la base
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Usuario y contraseña SQL con los que se accede a la base. Ese login queda como owner.
        {createsDatabase ? ' Si la base todavía no existe, se crea.' : ''}
      </Typography>
    </Grid>
    <Grid item xs={12} md={6}>
      <TextField
        name="ownerUsername"
        label="Usuario SQL"
        value={username}
        onChange={onChange}
        required
        fullWidth
        disabled={disabled}
        autoComplete="off"
        helperText="Letra inicial; después letras, números o guion bajo"
        inputProps={{ maxLength: 128 }}
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <TextField
        name="ownerPassword"
        label="Contraseña"
        type="password"
        value={password}
        onChange={onChange}
        required
        fullWidth
        disabled={disabled}
        autoComplete="new-password"
        helperText="Mínimo 6 caracteres"
        inputProps={{ maxLength: 128 }}
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <TextField
        name="ownerPasswordConfirm"
        label="Confirmar contraseña"
        type="password"
        value={confirmPassword}
        onChange={onChange}
        required
        fullWidth
        disabled={disabled}
        autoComplete="new-password"
        inputProps={{ maxLength: 128 }}
      />
    </Grid>
  </>
);

export default TenantOwnerLoginFields;
